module.exports = __webpack_public_path__ + "img/dept-12.fb414f43.svg";